// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid p {
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1rem;
}

.gallery-images .row:nth-child(2) {
  flex-wrap: nowrap;
  overflow: scroll;
}
.gallery-images .row:nth-child(2) .col {
  margin-left: 2px;
  margin-right: 2px;
  min-width: 80px;
  max-width: 100px;
}
.gallery-images img {
  width: 80px;
  min-width: 80px;
  height: 80px;
  border-radius: 8px;
}
.gallery-images h2 {
  text-transform: capitalize;
}

.ios.platform-cordova my-games ion-grid {
  padding-bottom: 0;
}
.ios.platform-cordova my-games ion-grid h2 {
  font-weight: bold;
  padding-left: 12px;
}
.ios.platform-cordova my-games ion-grid img {
  border-radius: 4px;
  height: 73px;
  min-width: 73px;
  width: 73px;
}
@media screen and (orientation: landscape) {
  .ios.platform-cordova my-games ion-grid img {
    height: 50px;
    width: 50px;
  }
}
.ios.platform-cordova my-games ion-grid p {
  font-size: 12px;
  font-weight: normal;
  margin-top: 8px;
  margin-right: 26px;
  margin-bottom: 0;
  padding-left: 0;
  text-align: center;
  text-transform: none;
}
.ios.platform-cordova my-games ion-grid p.heading {
  font-size: 2.4rem;
  margin-bottom: 11px;
  padding-left: 12px;
  text-align: left;
  text-transform: initial;
}
@media screen and (orientation: landscape) {
  .ios.platform-cordova my-games ion-grid p.heading {
    font-size: 2rem;
    margin-bottom: 5px;
    margin: 0 !important;
  }
}
.ios.platform-cordova my-games ion-grid .row:nth-child(2) .col {
  margin-left: 0;
  padding-bottom: 0;
}
.ios.platform-cordova my-games ion-grid .row:nth-child(2) .col:first-of-type {
  margin-left: 12px;
}
.ios.platform-cordova my-games ion-grid .row:nth-child(2)::-webkit-scrollbar {
  display: none;
}
.ios.platform-cordova my-games .gallery-images {
  padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/last-played-games/last-played-games.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAAR;;AAKI;EACI,iBAAA;EACA,gBAAA;AAFR;AAIQ;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAFZ;AAMI;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAJR;AAOI;EACI,0BAAA;AALR;;AAYQ;EACI,iBAAA;AATZ;AAWY;EACI,iBAAA;EACA,kBAAA;AAThB;AAYY;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAVhB;AAYgB;EANJ;IAOQ,YAAA;IACA,WAAA;EATlB;AACF;AAYY;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;AAVhB;AAYgB;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAVpB;AAYoB;EAPJ;IAQQ,eAAA;IACA,kBAAA;IACA,oBAAA;EATtB;AACF;AAcgB;EACI,cAAA;EAEA,iBAAA;AAbpB;AAeoB;EACI,iBAAA;AAbxB;AAkBY;EACI,aAAA;AAhBhB;AAoBQ;EACI,mBAAA;AAlBZ","sourcesContent":["ion-grid {\n    p {\n        color: #fff;\n        font-weight: bold;\n        text-transform: uppercase;\n        font-size: 1rem;\n    }\n}\n\n.gallery-images {\n    .row:nth-child(2) {\n        flex-wrap: nowrap;\n        overflow: scroll;\n\n        .col {\n            margin-left: 2px;\n            margin-right: 2px;\n            min-width: 80px;\n            max-width: 100px;\n        }\n    }\n\n    img {\n        width: 80px;\n        min-width: 80px;\n        height: 80px;\n        border-radius: 8px;\n    }\n\n    h2 {\n        text-transform: capitalize;\n    }\n}\n\n\n.ios.platform-cordova {\n    my-games {\n        ion-grid {\n            padding-bottom: 0;\n\n            h2 {\n                font-weight: bold;\n                padding-left: 12px;\n            }\n\n            img {\n                border-radius: 4px;\n                height: 73px;\n                min-width: 73px;\n                width: 73px;\n\n                @media screen and (orientation:landscape) {\n                    height: 50px;\n                    width: 50px;\n                }\n            }\n\n            p {\n                font-size: 12px;\n                font-weight: normal;\n                margin-top: 8px;\n                margin-right: 26px;\n                margin-bottom: 0;\n                padding-left: 0;\n                text-align: center;\n                text-transform: none;\n\n                &.heading {\n                    font-size: 2.4rem;\n                    margin-bottom: 11px;\n                    padding-left: 12px;\n                    text-align: left;\n                    text-transform: initial;\n\n                    @media screen and (orientation:landscape) {\n                        font-size: 2rem;\n                        margin-bottom: 5px;\n                        margin: 0 !important;\n                    }\n                }\n            }\n\n            .row:nth-child(2) {\n                .col {\n                    margin-left: 0;\n                    //   margin-right: 30px;\n                    padding-bottom: 0;\n\n                    &:first-of-type {\n                        margin-left: 12px;\n                    }\n                }\n            }\n\n            .row:nth-child(2)::-webkit-scrollbar {\n                display: none;\n            }\n        }\n\n        .gallery-images {\n            padding-bottom: 5px;\n            //   background: #000;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
